import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isoWeek from 'dayjs/plugin/isoWeek'
import utc from 'dayjs/plugin/utc'

dayjs.extend(customParseFormat)
dayjs.extend(isoWeek)
dayjs.extend(utc)

const API_DATETIME = 'YYYY-MM-DD HH:mm'

function parseCertificationApiDateTime(value) {
  if (!value) {
    return dayjs(value)
  }
  const parsed = dayjs(value, API_DATETIME, true)
  if (parsed.isValid()) {
    return parsed
  }
  // Enrolment options historycznie zwracało ATOM w UTC — godzina „zegarowa” bez przesunięcia TZ
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\+00:00|Z)$/.test(value)) {
    return dayjs.utc(value)
  }
  return dayjs(value)
}

export function certificationKindGenitive(kind) {
  if (kind === 'HEAD_OF_SALES') {
    return 'kierownika sprzedaży'
  }
  return 'doradcy ds. sprzedaży'
}

export function isCertificationSlotBookable(slot) {
  if (slot.available === true) {
    return true
  }
  if (slot.available === false) {
    return false
  }
  return slot.taken !== true
}

export function formatCertificationSlotTime(iso) {
  const d = parseCertificationApiDateTime(iso)
  return `${d.format('YYYY-MM-DD')} ${d.format('HH:mm')}`
}

export function formatCertificationSlotClock(iso) {
  return parseCertificationApiDateTime(iso).format('HH:mm')
}

export function datesWithAvailabilitySet(options) {
  const d = options && options.datesWithAvailability
  return new Set(Array.isArray(d) ? d : [])
}

/** Czy API opcji zapisu zwróciło choć jeden dzień z faktycznie możliwym zapisem. */
export function hasBookableCertificationTerms(options) {
  const dates = options && options.datesWithAvailability
  return Array.isArray(dates) && dates.length > 0
}

export function certificationsForDay(options) {
  const c = options && options.certificationsForDay
  return Array.isArray(c) ? c : []
}

export function buildCertificationCalendarWeeks(visibleMonth, datesSet) {
  const m = visibleMonth
  const availability = datesSet instanceof Set ? datesSet : new Set(datesSet || [])
  const start = m.startOf('month').startOf('isoWeek')
  const end = m.endOf('month').endOf('isoWeek')
  const cells = []
  let cur = start
  while (!cur.isAfter(end, 'day')) {
    const ymd = cur.format('YYYY-MM-DD')
    cells.push({
      key: ymd,
      date: cur,
      outsideMonth: cur.month() !== m.month(),
      hasAvailability: availability.has(ymd),
    })
    cur = cur.add(1, 'day')
  }
  const weeks = []
  for (let i = 0; i < cells.length; i += 7) {
    weeks.push(cells.slice(i, i + 7))
  }
  return weeks
}

export function buildCertificationEnrolConfirmMessage(options, pendingSlotTime) {
  if (!options || !pendingSlotTime) {
    return ''
  }
  const u = options.targetUser
  const name = `${u.firstName} ${u.lastName}`.trim()
  const kindG = certificationKindGenitive(options.kind)
  const when = formatCertificationSlotTime(pendingSlotTime)
  return `Czy potwierdzasz zapis ${name} na Certyfikacje dla ${kindG} w terminie ${when}?`
}

export function resolveEnrolmentBootstrapError(response) {
  if (response && response.status === 200) {
    return null
  }
  if (response && response.status === 403) {
    return 'Ten widok jest dostępny tylko dla menedżera.'
  }
  return 'Nie udało się wczytać danych zapisu.'
}

export function buildEnrolmentHeaderLine(options) {
  if (!options || !options.targetUser) {
    return ''
  }
  const u = options.targetUser
  const name = `${u.firstName} ${u.lastName}`.trim()
  const roman = options.certificationLevelRoman || '—'
  const kind = options.kindLabel || '—'
  return `Zapis ${name} na certyfikację ${roman} dla ${kind}`
}
